/**
 * /my-coaching/business/nova/routines — NOVA › Routines. The page itself
 * sends a coach without routines (no paid plan) back to NOVA Home.
 */

import { createFileRoute } from "@tanstack/react-router";

import { RoutinesPage } from "~/components/nova/routines/routines-page";
import { novaRoutinesQueryOptions } from "~/lib/queries/novaRoutinesQuery";

export const Route = createFileRoute(
  "/_user/my-coaching/business/nova/routines",
)({
  staticData: { title: "Routines" },
  loader: async ({ context }) => {
    // An optimisation for SSR; the page reads the same query and shows its
    // own error and retry.
    await context.queryClient
      .ensureQueryData(novaRoutinesQueryOptions())
      .catch(() => undefined);
  },
  component: RoutinesPage,
});
